module.exports = {"blocks":[{"type":"sections/index/index_hero","prefix":"index_hero"},{"type":"sections/index/index_download","prefix":"index_download"},{"type":"sections/index/index_service","prefix":"index_service"},{"type":"sections/index/index_feature","prefix":"index_feature"},{"type":"sections/index/index_howitwork","prefix":"index_howitwork"},{"type":"sections/index/index_newsletter_subscriptions","prefix":"index_newsletter_subscriptions"},{"type":"sections/index/index_media","prefix":"index_media"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/hk/en_hk/setting/index/setting.json
// module id = 599
// module chunks = 0 1 2 3 4 5